module.exports = __webpack_public_path__ + "img/american-express.74ffce27.svg";